module.exports = __webpack_public_path__ + "img/SMS54134-L-min.32c19223.png";